import { useOrg } from '~/support/composables/org';

export default defineNuxtPlugin(() => {
  const { getOrgContentModeLabel } = useOrg();

  return {
    provide: {
      getOrgContentModeLabel,
    },
  };
});
